module.exports = __webpack_public_path__ + "images/emoji/sparkles.98ace1fb8685530e95c3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sparkles.png
// module id = QpmQ
// module chunks = 14